module.exports = __webpack_public_path__ + "img/测点_编码器.efde3777.png";